import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const SET_IS_NEW_PUBLISH_TERMS_ENABLED = 'PUBLISH_TERMS :: IS_NEW_PUBLISH_TERMS_ENABLED :: SET';

export type TSetIsNewPublishTermsEnabledAction = IReduxAction<typeof SET_IS_NEW_PUBLISH_TERMS_ENABLED, boolean>;

export const setIsNewPublishTermsEnabled = actionGenerator<typeof SET_IS_NEW_PUBLISH_TERMS_ENABLED, boolean>(
  SET_IS_NEW_PUBLISH_TERMS_ENABLED,
);
